// extracted by mini-css-extract-plugin
module.exports = {"tabs_wrapper":"TemplateTabs_tabs_wrapper__rN7Jb","spinner_wrapper":"TemplateTabs_spinner_wrapper__2wAkV"};